import { render, staticRenderFns } from "./channels-layout.vue?vue&type=template&id=505915fc"
import script from "./channels-layout.vue?vue&type=script&lang=js"
export * from "./channels-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports